import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TSBreadcrumbItem, TSBreadcrumbItemEvent, TSBreadcrumbSize, TSBreadcrumbVariant } from './ts-breadcrumb.types';
@Component({
  selector: 'ts-breadcrumb',
  templateUrl: './ts-breadcrumb.component.html',
  styleUrls: ['./ts-breadcrumb.component.scss'],
})
export class TsBreadcrumbComponent implements OnInit {
  @Input() items: TSBreadcrumbItem[] = [];
  @Input() variant: TSBreadcrumbVariant = 'default';
  @Input() size: TSBreadcrumbSize = 'default';
  @Output() itemClick: EventEmitter<TSBreadcrumbItemEvent> = new EventEmitter<TSBreadcrumbItemEvent>();

  constructor() {}

  ngOnInit() {}

  onItemClick(event, item: TSBreadcrumbItem) {
    if (item.disabled) {
      event.preventDefault();
      return;
    }

    if (!item.routerLink) {
      event.preventDefault();
    }

    this.itemClick.emit({
      originalEvent: event,
      item,
    });
  }
}
